import { z } from 'zod';

// Problem details, RFC 9457, enrichi du `request_id` de la requête.
export const problemSchema = z.object({
  type: z.string(),
  title: z.string(),
  status: z.number().int(),
  detail: z.string().optional(),
  request_id: z.string(),
});

export type Problem = z.infer<typeof problemSchema>;
